export const STORAGE_CHAT_BUCKET = `chat`;
